<div class="stepper-container">

<div class="row" style="justify-content: center;">
    <h2>My Profile</h2>
  </div>
<form [formGroup]="secondFormGroup">
    
    <br />
        <div class="row">
          <div class="column">
            <mat-form-field appearance="outline">
              <mat-label>Fist Name</mat-label>
              <input matInput  placeholder="Fist Name"
                     required>
                    </mat-form-field>
              
          </div>
          <div class="column">
            <mat-form-field appearance="outline" >
              <mat-label>Last Name</mat-label>
              <input placeholder="Last Name"
                     >
            </mat-form-field>
         
          </div>
        </div>
        <div class="row">
          <div class="column">
            <mat-form-field appearance="outline">
              <mat-label>Email</mat-label>
              <input required matInput formControlName="email" placeholder="Email"
                     >
            </mat-form-field>
            <div *ngIf="secondFormGroup.controls['email'].invalid && (secondFormGroup.controls['email'].touched )" class="alert">
              <div *ngIf="secondFormGroup.controls['email'].errors">
                <mat-error>email is invalid</mat-error> 
            </div>
          </div>
          </div>

          <div class="column">
            <mat-form-field appearance="outline" >
              <mat-label>Phone Number</mat-label>
              <input matInput formControlName="phoneNumber" placeholder="Phone Number"
                     >
            </mat-form-field>
   
            <div *ngIf="secondFormGroup.controls['phoneNumber'].invalid && (secondFormGroup.controls['phoneNumber'].touched )" class="alert">
              <div *ngIf="secondFormGroup.controls['phoneNumber'].errors">
                <mat-error>Phone Number is required</mat-error> 
            </div>
          </div>
          </div>
        </div>
        <div class="row">
          <div class="column">
            <mat-form-field appearance="outline">
              <mat-label>Password</mat-label>
              <input matInput formControlName="password" placeholder="Password"
                     >
            </mat-form-field>
            <div *ngIf="secondFormGroup.controls['password'].invalid && (secondFormGroup.controls['password'].touched || secondFormGroup.controls['password'].dirty )" class="alert">
              <div *ngIf="secondFormGroup.controls['password'].errors">
                <mat-error>Password is required</mat-error> 
            </div>
          </div>
          </div>


          <div class="column">
            <mat-form-field appearance="outline" >
              <mat-label>Confirm Password</mat-label>
              <input matInput formControlName="confirmPassword" placeholder="Confirm Password"
                     >
            </mat-form-field>
            <div *ngIf="secondFormGroup.controls['password'].invalid && (secondFormGroup.controls['password'].touched )" class="alert">
              <div *ngIf="secondFormGroup.controls['password'].errors">
                <mat-error>Confirm Password is required</mat-error> 
            </div>
          </div>
          </div>
        </div>
      
          <mat-tab-group >
            <mat-tab label="Domestic"> 
              <br />
              <div class="row">
                <div class="column">
                  <mat-form-field appearance="outline" >
                    <mat-label>Owners Street Address</mat-label>
                    <input class="form-outline form-control" matInput formControlName="address1" placeholder="Owners Street Address"
                           >
                  </mat-form-field>
                </div>

                <div class="column">
                  <mat-form-field appearance="outline" >
                    <mat-label>Apt/Unit/Suite</mat-label>
                    <input matInput formControlName="address2" placeholder="Apt/Unit/Suite"
                           >
                  </mat-form-field>
                </div>
              </div>
                <div class="row">
                  <div class="column">
                  <mat-form-field appearance="outline" >
                    <mat-label>City</mat-label>
                    <input matInput formControlName="city" placeholder="City"
                           >
                  </mat-form-field>
                </div>

                <div class="column">
                  <mat-form-field appearance="outline" >
                    <mat-label>State</mat-label>

                           <mat-select formControlName="state"  placeholder="State">
                          
                            @for (state of states; track state) {
                              <mat-option [value]="state.id">{{state.name}}</mat-option>
                            }
                          </mat-select>
                  </mat-form-field>
                </div>


                <div class="column">
                  <mat-form-field appearance="outline" >
                    <mat-label>Zip Code</mat-label>
                    <input matInput formControlName="zipCode" placeholder="Zip Code"
                           >
                  </mat-form-field>
                  <div *ngIf="secondFormGroup.controls['zipCode'].invalid " class="alert">
                    <div *ngIf="secondFormGroup.controls['zipCode'].errors">
                      <mat-error>Invalid Zip Code</mat-error> 
                  </div>
                </div>
                 
                </div>
              </div>
          
            </mat-tab>
            <mat-tab label="International"> 
              <div class="flex-col-12">
                <mat-form-field appearance="outline" >
                  <mat-label>Addressee's Full Legal name</mat-label>
                  <input matInput formControlName="internationalAddressName" placeholder="Addressee's Full Legal name"
                         >
                </mat-form-field>
              </div>  
              <div class="flex-col-12">
                <mat-form-field appearance="outline" >
                  <mat-label>Street Address or Post Office Box Number</mat-label>
                  <input matInput formControlName="internationalPoBox" placeholder="Street Address or Post Office Box Number"
                         >
                </mat-form-field>
              </div>  
              <div class="flex-col-12">
                <mat-form-field  appearance="outline" >
                  <mat-label>City, State, Province and Postal Code</mat-label>
                  <input matInput formControlName="internationalCityProvinceState" placeholder="City, State, Province and Postal Code"
                         >
                </mat-form-field>
              </div>  

              <div class="flex-col-12">
                <mat-form-field appearance="outline" >
                  <mat-label>Country</mat-label>
                  <input matInput formControlName="internationalCountry" placeholder="Country"
                         >
                </mat-form-field>
              </div>  
                          
            </mat-tab>   
          </mat-tab-group>
         
          <p>
            Are you using a tax reporting representative?
            <mat-button-toggle-group class="primary"  value="no" name="fontStyle" aria-label="Font Style">
              <mat-button-toggle class="primary"  (click)="showAndHideTaxForm(false)" value="no">No</mat-button-toggle>
              <mat-button-toggle  class="primary" (click)="showAndHideTaxForm(true)" value="yes">Yes</mat-button-toggle>
            </mat-button-toggle-group>
          </p>
          <div *ngIf="showTaxRepresentativeForm" class="flex-row">
            <div class="flex-col-6 ">
              <mat-form-field appearance="outline">
                <mat-label>Fist Name</mat-label>
                <input matInput formControlName="firstNameTax" placeholder="Fist Name"
                       >
                      </mat-form-field>
            </div>
            <div class="flex-col-6 ">
              <mat-form-field appearance="outline" >
                <mat-label>Last Name</mat-label>
                <input matInput formControlName="lastNameTax" placeholder="Last Name"
                       >
              </mat-form-field>
            </div>

            <div class="flex-col-6 ">
              <mat-form-field appearance="outline" >
                <mat-label>Email</mat-label>
                <input required={{this.showTaxRepresentativeForm}} matInput formControlName="emailTax" placeholder="Email"
                       >
              </mat-form-field>
              <div *ngIf="secondFormGroup.controls['emailTax'].invalid " class="alert">
                <div *ngIf="secondFormGroup.controls['emailTax'].errors">
                  <mat-error>Invalid Zip Code</mat-error> 
              </div>
            </div>
             
            </div>
 
            <div class="flex-col-6 ">
              <mat-form-field appearance="outline" >
                <mat-label>Phone Number</mat-label>
                <input matInput  placeholder="Phone Number"
                       >
              </mat-form-field>
            </div>
   
              <div class="flex-col-4">
                <mat-form-field appearance="outline" >
                  <mat-label>City</mat-label>
                  <input matInput formControlName="cityTax" placeholder="City"
                         >
                </mat-form-field>
              </div>

              <div class="flex-col-4">
                <mat-form-field appearance="outline" >
                  <mat-label>State</mat-label>
                  <input matInput  placeholder="State"
                         >
                </mat-form-field>
              </div>


              <div class="flex-col-4">
                <mat-form-field appearance="outline" >
                  <mat-label>Zip Code</mat-label>
                  <input matInput placeholder="Zip Code"
                         >
                </mat-form-field>
                
              </div>
            </div>
         
          <div class="flex-row">
            <mat-form-field appearance="outline">
              <mat-label>Notes</mat-label>
              <textarea matInput placeholder="Notes"></textarea>
            </mat-form-field>
          </div> 
        
      <div>
        <div class="flex-row">
        <button mat-flat-button color="primary">Save</button>
      </div>
      </div>
    </form>
</div>